import React, { useEffect, useState } from 'react';
import DatePicker, { registerLocale } from 'react-datepicker';
import en from 'date-fns/locale/en-GB';
import pl from 'date-fns/locale/pl';
import { CalendarWrapper } from './index.styles';
import { CalendarProps, CalendarRangeProps } from './index.interfaces';
import { useLanguage } from 'src/common/hooks';

registerLocale('en', en);
registerLocale('pl', pl);

export default function BigCalendar({
  startDate,
  currDate,
  endDate,
  setDate,
  reportingPeriod,
}: CalendarProps) {
  const { language } = useLanguage();

  const handleChange = (date: Date) => {
    //@ts-ignore
    setDate(date);
  };

  let minDate = startDate ? new Date() : undefined;
  let maxDate = startDate ? undefined : new Date();

  if (!startDate && !endDate) {
    minDate = undefined;
    maxDate = undefined;
  }

  return (
    <CalendarWrapper period={reportingPeriod}>
      {reportingPeriod !== 'Q' ? (
        <DatePicker
          selected={currDate}
          onChange={handleChange}
          showMonthYearPicker={reportingPeriod === 'M'}
          showYearPicker={reportingPeriod === 'Y'}
          minDate={minDate}
          maxDate={maxDate}
          dateFormat="MMMM yyyy"
          inline
          locale={language}
          calendarClassName="calendar"
        />
      ) : (
        <DatePicker
          calendarClassName="calendar"
          selected={currDate}
          onChange={handleChange}
          dateFormat="QQQ yyyy"
          showQuarterYearPicker
          locale={language}
          minDate={minDate}
          maxDate={maxDate}
          inline
        />
      )}
    </CalendarWrapper>
  );
}

export function BigCalendarRange({
  startDate,
  endDate,
  handleChange,
  reportingPeriod,
}: CalendarRangeProps) {
  const { language } = useLanguage();
  const [lang, setLang] = useState<string>(language);

  useEffect(() => {
    setLang(language);
  }, [language]);

  return (
    <CalendarWrapper period={reportingPeriod}>
      {reportingPeriod !== 'Q' ? (
        <DatePicker
          //@ts-ignore
          onChange={handleChange}
          showMonthYearPicker={reportingPeriod === 'M'}
          showYearPicker={reportingPeriod === 'Y'}
          maxDate={new Date()}
          minDate={undefined}
          dateFormat="MMMM yyyy"
          startDate={startDate}
          endDate={endDate}
          inline
          selectsRange
          locale={lang}
          calendarClassName="calendar"
        />
      ) : (
        <DatePicker
          calendarClassName="calendar"
          //@ts-ignore
          onChange={handleChange}
          selectsRange
          dateFormat="QQQ yyyy"
          startDate={startDate}
          endDate={endDate}
          showQuarterYearPicker
          locale={lang}
          maxDate={new Date()}
          minDate={undefined}
          inline
        />
      )}
    </CalendarWrapper>
  );
}
